import axios from 'axios';
const header = {
  'Content-Type': 'application/json',
}

/*****************************First Fetched Masked Email and Mobile**************************** */
export const getMaskedPhoneAndEmail = async (activityId, eventCode, coapplicant) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_4f969b16", 
        "activityid": `${activityId}`,
        "coapplicant": `${coapplicant}`,
        "eventcode": `${eventCode}`
      },
      "orgId": "53450",
      "data": {
        "lappBody": {}
      }
    })
  }
  return await axios(config)
}
/************************************************************************************************ */


export const getLeadDetailsByIdAndCoApplicantId = async (
  leadId,
  activityId,
  eventCode,
  coapplicant,
  mobileOtp
) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_8a077678",//uat
        "leadid": `${leadId}`,
        "activityid": `${activityId}`,
        "eventcode": `${eventCode}`,
        "coapplicant": `${coapplicant}`,
        "cacheMobileOtp": `${mobileOtp}`
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {}
      }
    })
  }
  return await axios(config);
}

export const sendOtpToMobileNumber = async (activityId, coapplicant, eventcode) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_fac81f28",
        "otp": "send"
      },
      "orgId": "53450",

      "data": {
        "lappBody": {
          activityid: activityId,
          coapplicant: coapplicant,
          eventcode: eventcode,
          messageType: 'consent'
        }
      }
    })
  }
  return await axios(config);
}

export const verifyOtpFromApi = async (activityId, eventcode, coapplicant, otp) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_fac81f28",// uat
        "otp": "verify"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          activityid: activityId,
          coapplicant: coapplicant,
          eventcode: eventcode,
          otp: otp,
        }
      }
    })
  }

  return await axios(config);
}

export const acceptConsentApi = async (body, info, mobileOtp) => {
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_8a077678", //uat

        "eventType": "acceptconsent"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          activityid: body?.activityId,
          coapplicant: body?.coapplicant,
          eventcode: body?.eventcode,
          leadId: body?.leadId,
          consentInformation: info,
          cacheMobileOtp: mobileOtp


        },
      }
    })
  }
  return await axios(config);
}

export const consentPostProcessApi = async (body, info, mobileOtp) => {
  console.log("Consent Post processing..");
  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_8a077678", //uat
        "eventType": "consentPostProcess",
        "compressrequestbody": "1"
      },
      "orgId": "53450",//uat

      "data": {
        "lappBody": {
          activityid: body?.activityId,
          coapplicant: body?.coapplicant,
          eventcode: body?.eventcode,
          leadId: body?.leadId,
          consentInformation: info,
          cacheMobileOtp: mobileOtp

        },
      }
    })
  }

  return await axios(config);
}

//parellel api call
export const consentCreatePostProcessApi = async (body, info, mobileOtp) => {
  const config = await Promise.all([acceptConsentApi(body, info, mobileOtp), consentPostProcessApi(body, info, mobileOtp)]);
  return config;
}

export const logVerificationResponse = async (activityId, coapplicant, eventcode, leadId, status, mobileOtp) => {

  var config = {
    method: 'post',
    url: `https://pstech.leadsquaredapps.com/lapp-proxy`,
    headers: header,
    data: ({
      "method": "post",
      "params": {
        "stage": "Test",
        "name": "da_53450_8a077678", //uat

        "eventType": "logVerificationDetails",
        "otpStatus": `${status}`
      },
      "orgId": "53450", //uat

      "data": {
        "lappBody": {
          activityid: activityId,
          coapplicant: coapplicant,
          eventcode: eventcode,
          leadId: leadId,
          cacheMobileOtp: mobileOtp
        }
      }
    })
  }
  return await axios(config);
}


